import { Tabs as KitTabs } from "@lcc/ui";
import { useId, type ReactNode } from "react";

export interface TabSpec<K extends string> {
  key: K;
  label: string;
  count?: number;
  /** Red words (an emergency); the label must say it too. */
  tone?: "danger";
}

/**
 * The Hub's pill tabs (tablist with arrow keys, Home and End, one tab stop) and the panel of the selected one. Only the
 * visible tabs are passed in (role gating).
 */
export function Tabs<K extends string>({
  label,
  tabs,
  current,
  onChange,
  children,
}: {
  label: string;
  tabs: ReadonlyArray<TabSpec<K>>;
  current: K;
  onChange: (key: K) => void;
  children: ReactNode;
}) {
  const id = useId().replace(/:/g, "");
  const active = tabs.some((t) => t.key === current) ? current : tabs[0]?.key;
  return (
    <div className="fer-tabset">
      <KitTabs
        label={label}
        idBase={id}
        tabs={tabs.map((t) => ({ value: t.key, label: t.label, count: t.count, tone: t.tone }))}
        value={active as K}
        onChange={onChange}
      />
      <div role="tabpanel" id={`${id}-panel-${active}`} aria-labelledby={`${id}-tab-${active}`} className="fer-tabpanel">
        {children}
      </div>
    </div>
  );
}
